import ApiERP from '@/core/conectores/ApiERP';
import { IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { IDadosRelatorio, IDadosRelatorioCampo } from '@/models/Entidades/Relatorios/DadosRelatorio';
import { IItemConsultaRapida } from '@/core/models/Consulta/IItemConsultaRapida';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';

/**
 * Serviço Dados Relatorio.
 */

class ServicoDadosRelatorio {
    endPoint = 'dados-relatorio';

    apiERP = new ApiERP();

    public requisicaoSistema():void{
      this.apiERP = new ApiERP(true);
    }

    public async consultaRapida(parametrosConsultaRapida: IParametrosConsultaRapida, modulo: number): Promise<IItemConsultaRapida[]> {
      console.log('vai chamar backend');
      const parametrosAdicionais = this.apiERP.obterParametrosAdicionaisConsultaRapida(parametrosConsultaRapida);
      const result: any = await this.apiERP.get(`${this.endPoint}/consulta-rapida/${modulo}/modulo${parametrosAdicionais}`);
      return result.data;
    }

    public async incluir(dadosRelatorio: IDadosRelatorio): Promise<IRetornoRequisicao> {
      const result: any = await this.apiERP.post(`${this.endPoint}`, dadosRelatorio);
      return result.data;
    }

    public async alterar(dadosRelatorio: IDadosRelatorio): Promise<IRetornoRequisicao> {
      const result: any = await this.apiERP.put(`${this.endPoint}/${dadosRelatorio.codigo}`, dadosRelatorio);
      return result.data;
    }

    public async obter(codigo: number, empresa: number): Promise<IDadosRelatorio> {
      const result: any = await this.apiERP.get(`${this.endPoint}/${codigo}/empresa/${empresa}`);
      return result.data;
    }

    public async obterCampos(codigo: number, empresa: number): Promise<IDadosRelatorioCampo[]> {
      const result: any = await this.apiERP.get(`${this.endPoint}/campos/${codigo}/empresa/${empresa}`);
      return result.data;
    }

    public async obterCodigo(empresa: number, modulo: number): Promise<number> {
      const result: any = await this.apiERP.get(`${this.endPoint}/obter/${empresa}/modulo/${modulo}`);
      return result.data;
    }

    public async excluir(codigo: number): Promise<IRetornoRequisicao> {
      const result: any = await this.apiERP.delete(`${this.endPoint}/${codigo}`);
      return result.data;
    }
}
export default ServicoDadosRelatorio;
